import React from 'react';
import {
  Pane, Heading, TextInputField, Checkbox, Button, Alert, UnorderedList, ListItem,
} from 'evergreen-ui';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import * as yup from 'yup';
import { unwrapResult } from '@reduxjs/toolkit';
import { isAuthSelector, useLoginMutation } from 'Services/auth.service';

const validationSchema = yup.object().shape({
  username: yup
    .string()
    .required('Введите Имя'),
  password: yup
    .string()
    .required('Введите Пароль'),
});

function LoginForm() {
  const location = useLocation();

  const isAuth = useSelector(isAuthSelector);

  const [login, { isLoading }] = useLoginMutation();

  const [username, setUsername] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [remember, setRemember] = React.useState(false);
  const [error, setError] = React.useState([]);

  const errorRemove = () => setError([]);

  const submit = async () => {
    // TODO
    errorRemove();
    validationSchema
      .validate({ username, password, remember }, { abortEarly: false })
      .then(async () => {
        try {
          const loginRequest = await login({ username, password, remember });
          // получить результат вызова dispatch(login(...
          // если там был throw Error мы попадем в catch здесь
          unwrapResult(loginRequest);
          // console.log('realLoginRequest', realLoginRequest);
        } catch (err) {
          // если не сделать unwrapResult, то сюда не попадет по ошибке
          console.log('login error', err);
          setError([err.data.message]);
        }
      })
      .catch(({ errors }) => {
        setError(errors);
      });
  };

  const keyPressSubmit = (e) => e.key === 'Enter' && setTimeout(submit, 0);

  if (isAuth) {
    return <Navigate to={location.state?.from || '/'} replace state={{ from: location.pathname }} />;
  }
  return (
    <Pane
      display="flex"
      flex="1"
      alignItems="center"
      height="100%"
      justifyContent="center"
    >
      <Pane
        display="flex"
        flexDirection="column"
        elevation={1}
        width={320}
      >
        <Pane
          display="flex"
          alignItems="center"
          justifyContent="center"
          borderBottom="default"
          padding={8}
          background="tint2"
        >
          <Heading>{process.env.REACT_APP_TITLE}</Heading>
          {/*<Heading>СПО ЦСОД</Heading>*/}
        </Pane>
        <form method="post">
          <Pane
            display="flex"
            flexDirection="column"
            padding={8}
            background="white"
          >
            {error?.length > 0 && (
              <Alert
                intent="danger"
                title="Ошибка входа"
                marginBottom={16}
                isRemoveable
                onRemove={errorRemove}
              >
                <UnorderedList>
                  {error.map((err) => <ListItem key={err}>{err}</ListItem>)}
                </UnorderedList>
              </Alert>
            )}

            <TextInputField
              label="Имя"
              name="username"
              autoFocus
              autoComplete="username"
              value={username}
              onChange={({ target: { value } }) => setUsername(value)}
              onKeyPress={keyPressSubmit}
              height={40}
            />
            <TextInputField
              label="Пароль"
              name="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={({ target: { value } }) => setPassword(value)}
              onKeyPress={keyPressSubmit}
            />
            <Checkbox
              checked={remember}
              name="remember"
              onChange={({ target: { checked } }) => setRemember(checked)}
              label="Запомнить на этом компьютере"
            />
          </Pane>
          <Pane
            display="flex"
            justifyContent="flex-end"
            background="tint2"
            padding={8}
            borderTop="default"
          >
            <Button
              appearance="primary"
              intent="success"
              type="button"
              disabled={isLoading}
              isLoading={isLoading}
              onClick={submit}
            >
              Войти
            </Button>
          </Pane>
        </form>
      </Pane>
    </Pane>
  );
}

export default LoginForm;
